// import csc from 'country-state-city';
// import axios from 'axios';
//import BasicDocument from '../../Docs/ContratService';
import './styles.scss';
import './Client.scss';

//import { ArrowForward } from '@mui/icons-material';
//import {DrawFelicIcone} from '../../../data/SVGs';
//import SaveAltIcon from '@mui/icons-material/SaveAlt';
//import Button from '@mui/material/Button';
import { motion } from 'framer-motion';
//import JsPDF from 'jspdf';
import React, { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import AuthContext from '../../../Contexts/AuthProvider';
import useWindowSize from '../../../hooks/useWindowSize';
import SideBarMobile from '../../Expert/CompleterProfile/SideBarMobile';
//import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import KbisClientExpert from '../DocAdministratifs/KbisClientExpert';
import DrawSideBar from './SideBarClient';

const ClientStep4 = () => {

    const { state } = useLocation();
    //const axiosPrivate = useAxiosPrivate();
    //const navigate = useNavigate();
    console.log('state',state);
    const {device}=useWindowSize();
    //const [checked, setChecked] = useState(false); //! it was false before removing Doc Contrat from this process
    //const handleClick = () => {
    //    setChecked(!checked);
    //    console.log(!checked);
    //};

    const { auth } = useContext(AuthContext);
    console.log('ContextAPI data : ', auth);

    useEffect(() => {
        // if (!state.state?.newCompany) {
        if (!state) {
            console.log('it is null');
        }
    }, [

    ]);

    // const downloadPdfDocument = () => {
    //     const input = document.getElementById('divToDownload');
    //     console.log(input)
    //     console.log('2')
    //     html2canvas(input)
    //       .then((canvas) => {
    //           const imgData = canvas.toDataURL('image/png');
    //           const pdf = new jsPDF();
    //           pdf.addImage(imgData, 'JPEG', 0, 0);
    //           pdf.save("download.pdf");
    //       })
    //   }

    //const contentStep4 = () => {
    ////    console.log('state in content ',state);
    ////    if (state) {
    ////        if (state?.state?.newCompany == true) {
    //    return (
    //        <>
    //            <div style={{display:'flex',flexDirection:'column',justifyContent:'space-between',width:'80%',alignItems: 'center',paddingTop: '64px'}}>
    //                <motion.div
    //                    initial={{ x: '-100vw' }}
    //                    animate={{ x: 0 }}
    //                    transition={{ stiffness: 150 }}
    //                    style={{width : '80%'}}
    //                >
    //                    <KbisClientExpert createCompte={'true'} />
    //                </motion.div>
    //            </div>
    //        </>

    //    );
    //    //}
    //    //else if (state?.state?.newCompany == false) {
    //    //    return (
    //    //        <div className='TextCenter'>
    //    //            <p>attendez que votre administrateur accepte l&apos;invitation, vous recevrez un e-mail à cet effet</p>
    //    //        </div>
    //    //    );
    //    //} else {
    //    //    return (
    //    //        <div className='TextCenter'>
    //    //            <h3>quelque chose ne va pas, veuillez revenir à l&apos;étape 2 et réessayer</h3>
    //    //        </div>
    //    //    );
    //    //}
    //    //}

    //    //else {
    //    //    return (
    //    //        <div className='TextCenter'>
    //    //            <h3>quelque chose ne va pas, veuillez revenir à l&apos;étape 2 et réessayer</h3>
    //    //        </div>
    //    //    );
    //    //}s

    //};

    return (
        <>
            <div style={{display:'flex',flexDirection:device=='desktop' ?'row':'column',alignSelf:'stretch'}}>
                {device=='desktop' &&
                <DrawSideBar />
                }
                {device!='desktop' &&
                    <SideBarMobile
                        etape={'Etape 3'}
                        etapSuivante=''
                        number='4'
                    />
                }
                {/*{contentStep4()}*/}
                <div style={{display:'flex',flexDirection:'column',justifyContent:'space-between',width:device=='desktop' ?'80%':'100%',alignItems: 'center',padding:device=='desktop'?'0px':'16px',paddingTop: '64px'}}>
                    <motion.div
                        initial={{ x: '-100vw' }}
                        animate={{ x: 0 }}
                        transition={{ stiffness: 150 }}
                        style={{width :device=='desktop'? '80%':'100%'}}
                    >
                        <KbisClientExpert createCompte={true} />
                    </motion.div>
                </div>
            </div>
        </>
    );
};

export default ClientStep4;
